import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CandidatService } from '../../services/candidat.service';
import { FlagType } from '../../shared/utils/enums';
import { FlagService } from '../../shared/services/flag.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { json } from 'stream/consumers';
import { CookieService } from 'ngx-cookie-service';
import moment from 'moment';

@Component({
  selector: 'app-candidat',
  templateUrl: './candidat.component.html',
  styleUrl: './candidat.component.scss',
})
export class CandidatComponent implements OnInit {
  @Input() step: number = 2;
  @Input() firstStepFormControl: FormGroup;
  @Input() secondStepFormControl: FormGroup;
  @Input() addressForm: FormGroup;
  @Input() thirdStepFormControl: FormGroup;
  @Output() onSubmit = new EventEmitter<any>();
  loading: boolean;
  // @Input() step: number;
  user: any;
  birthDay: string;
  graduationYear: string;
  firstStepForm: FormGroup = this.fb.group({
    id: [],
    photo: [''],
    civility: ['', Validators.required],
    firstname: ['', Validators.required],
    lastname: ['', Validators.required],
    fonction: ['', Validators.required],
    birthDay: ['', Validators.required],
    userName: [''],
    numtel: ['', Validators.required],
    key: ['', [Validators.minLength(2), Validators.maxLength(2)]],
    worktype: ['', Validators.required],
    numsiret: ['', [Validators.minLength(14), Validators.maxLength(14)]],
    numsocialsecurity: [
      '',
      [Validators.minLength(13), Validators.maxLength(13)],
    ],
    ishandicap: false,
    handicapsituation: [''],
  });

  secondStepForm: FormGroup = this.fb.group({
    adress: ['', Validators.required],
    address: [''],
    pays: ['', Validators.required],
    postalcode: ['', Validators.required],
    ville: ['', Validators.required],
    cededx: [''],
    departmentName: ['', Validators.required],
    regionName: [''],
    regionCode: [''],
    lat: [''],
    lon: [''],
    note: ['', [Validators.maxLength(50)]],
  });

  thirdStepForm: FormGroup = this.fb.group({
    nationality: [''],
    graduationYear :[''],
  });

  constructor(
    private fb: FormBuilder,
    private candidatService: CandidatService,
    private cookieService: CookieService,
    private flag: FlagService,
    private authService: AuthService,
    private router: Router,
    private auth: AuthService
  ) {
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    this.firstStepFormControl.valueChanges.subscribe((value) => {
      this.firstStepForm.patchValue({
        firstname: value?.firstName,
        lastname: value?.lastName,
        civility: value?.prefixe,
      });
    });
  }

  submit() {
    this.loading = true;
    const finalBody = {
      ...this.firstStepForm.value,
      ...this.secondStepForm.value,
      ...this.thirdStepForm.value,
    };

    this.user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') || '')
      : {};
    var numTel = finalBody.numtel;
    const body = {
      civility: finalBody.civility,
      lastname: finalBody.lastname,
      firstname: finalBody.firstname,
      fullname: finalBody.lastname + ' ' + finalBody.firstname,
      ishandicap: finalBody.ishandicap,
      handicapsituation: finalBody.handicapsituation,
      isliberal: false,
      birthDay: finalBody.birthDay,
      graduationYear : finalBody.graduationYear,
      mailadress: finalBody.mailadress || this.user.email,
      numsiret: finalBody.numsiret,
      description: finalBody.description,
      socialKey: finalBody.key,
      numsocialsecurity: finalBody.numsocialsecurity,
      numtel: numTel,
      typePosteId: finalBody.fonction,
      typeSecteurId: finalBody.worktype,
      adresseCandidatDto: {
        codePostale: finalBody.postalcode,
        additionalAdress: finalBody.adress,
        department: finalBody.departmentName,
        regionName: finalBody.regionName,
        regionCode: finalBody.regionCode,
        pays: finalBody.pays,
        lat: finalBody.lat,
        lon: finalBody.lon,
        ville: finalBody.ville,
      },
      nationality: finalBody.nationality,
    };
    body.numtel = this.firstStepForm.value?.numtel?.nationalNumber;
    this.candidatService
      .upadateCandidat(body, this.user?.collary_id)
      .subscribe({
        next: (res) => {
          this.flag.displayFlag(
            'Compte candidat crée avec succés !',
            FlagType.success
          );

          this.candidatService
            .getCondidatById(this.user?.collary_id)
            .subscribe({
              next: (res) => {
                this.cookieService.set('user', JSON.stringify(this.user));
                this.cookieService.set('id', res.id);
                localStorage.setItem(
                  'candidat',
                  JSON.stringify({
                    id: res.id,
                    firstname: res.firstname,
                    fullname: res.fullname,
                    mailadress: res.mailadress,
                    photo: res.photo,
                    lastname: res.firstname,
                    typePosteDto: res.typePosteDto,
                    typePosteId: res.typePosteId,
                    typeSecteurDto: res.typeSecteurDto,
                    typeSecteurId: res.typeSecteurId,
                    numsiret: res.numsiret,
                    numtel: res.numtel,
                    numsocialsecurity: res.numsocialsecurity,
                    nationality: res.nationality,
                    civility: res.civility,
                  })
                );
                localStorage.setItem(
                  'typePosteId',
                  JSON.stringify(res?.typePosteId)
                );
                this.cookieService.set(
                  'candidat',
                  JSON.stringify({
                    id: res.id,
                    firstname: res.firstname,
                    fullname: res.fullname,
                    photo: res.photo,
                    mailadress: res.mailadress,
                    lastname: res.firstname,
                    typePosteDto: res.typePosteDto,
                    typePosteId: res.typePosteId,
                    typeSecteurDto: res.typeSecteurDto,
                    typeSecteurId: res.typeSecteurId,
                    numsiret: res.numsiret,
                    numtel: res.numtel,
                    numsocialsecurity: res.numsocialsecurity,
                    nationality: res.nationality,
                    civility: res.civility,
                  })
                );
                this.router.navigateByUrl('/accueil');
                this.cookieService.set('user', JSON.stringify(this.user));
                this.cookieService.set('id', res.id);
                this.loading = false;
              },
              error: (err) => {
                this.loading = false;
              },
            });

          this.loading = false;
        },
        error: (err) => {
          console.log(err);
          this.flag.displayFlag(
            'Une erreur est survenue, vérifiez vos informations !',
            FlagType.error
          );
          this.loading = false;
        },
        complete: () => (this.loading = false),
      });
  }
}
